import { jsx as _jsx } from "react/jsx-runtime";
import { useContext, createContext } from "react";
import useInitPes from "hooks/pes/useInitPes";
var PesInitContext = /*#__PURE__*/ createContext(undefined);
export var PesInitProvider = function(param) {
    var children = param.children;
    var contextValue = useInitPes();
    return /*#__PURE__*/ _jsx(PesInitContext.Provider, {
        value: contextValue,
        children: children
    });
};
export var usePesInitContext = function() {
    var context = useContext(PesInitContext);
    if (!context) {
        throw new Error("usePesInitContext must be used within a Provider");
    }
    return context;
};
